import { render, staticRenderFns } from "./AppAnswerExplanation.vue?vue&type=template&id=75a39b1a&scoped=true"
import script from "./AppAnswerExplanation.vue?vue&type=script&lang=js"
export * from "./AppAnswerExplanation.vue?vue&type=script&lang=js"
import style0 from "./AppAnswerExplanation.vue?vue&type=style&index=0&id=75a39b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a39b1a",
  null
  
)

export default component.exports